import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const homeRoutes: RouteObject[] = [
  {
    index: true,
    element: lazyElement(() => import('./Dashboard')),
    handle: {
      documentTitle: 'Home',
      crumb: () => ({ label: 'Home', to: '/' })
    },
  },
];

export default homeRoutes;
